import { useFetchPage } from "~/core/composables/useFetchPage";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { OperationModel } from "~/core/models/OperationModel.interface";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import operationManagerService from "~/core/services/operationManager.service";
import filtersUtils from "~/core/utils/filters.utils";
import type { FiltersSelection } from "~/types";
import {
  Filters,
  FiltersType,
  OPERATOR_RSQL_ARRAY_CONTAINS,
  OPERATOR_RSQL_EQUAL,
  OPERATOR_RSQL_IN,
} from "~/types";

export function useFetchDtwinOperationModels({
  organizationCode,
  searchMode,
  useQueryParametersForPagination,
}: UseFetchParameters): UseFetchResponse<OperationModel> {
  const service = operationManagerService.getModels.bind(
    operationManagerService,
  );

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.DTWIN_OPERATION_MODEL_TYPE,
      {
        key: "type",
        operator: OPERATOR_RSQL_IN,
        value: [],
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.DTWIN_OPERATION_MODEL_DEVICE_TYPE,
      { key: "deviceTypes", operator: OPERATOR_RSQL_ARRAY_CONTAINS, value: [] },
    ],
    [
      Filters.DTWIN_OPERATION_MODEL_HIDDEN,
      {
        key: "hidden",
        operator: OPERATOR_RSQL_EQUAL,
        value: "",
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData, fetchAllData, allResults } =
    useFetchPage({
      organizationCode,
      service,
      searchParams,
      sort,
      useQueryParametersForPagination,
    });

  return {
    error,
    fetchData,
    fetchAllData,
    filters,
    isLoading,
    onSearch,
    onSortChange,
    results,
    allResults,
    search,
    setFilter,
    sort,
  };
}
